import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  template: `
    <div class="unauth-basic">
      <h3>Unauthorized</h3>
      <p>You do not have permission to view this page.</p>
    </div>
  `,
  styles: [`
    .unauth-basic { margin: 40px; }
    h3 { margin: 0 0 8px; }
    p { margin: 0; color: #64748b; }
  `]
})
export class UnauthorizedComponent {}
